<!--
 * @Descripttion: 
 * @version: 
 * @Author: gaolongzhi
 * @Date: 2020-04-01 11:29:08
 * @LastEditors: gaolongzhi
 * @LastEditTime: 2020-07-10 09:28:24
--> 
<template>
  <div class="indexPage" v-if="fileURL!=''">
    <job-header-simple :header_title="header_title"></job-header-simple>
    <pdf-view :file="fileURL" class="indexPage1"></pdf-view>
  </div>
</template>
<script>
import pdfView from "@/components/pdfView";
import jobHeaderSimple from "@/components/header/header.vue";
export default {
  components: {
    pdfView,
    jobHeaderSimple
  },
  data() {
    return {
      fileURL: "",
      header_title: this.$route.query.header_title
        ? this.$route.query.header_title
        : "查看协议"
    };
  },
  mounted: function() {
    this.setUrl();
  },
  methods: {
    setUrl() {
      this.fileURL = this.$route.query.fileURL;
    }
  }
};
</script>

<style lang="less" scoped>
.indexPage {
  height: 100%;
  position: absolute;
  top: 0px;
  left: 0px;
  width: 100%;
}
.indexPage1 {
  height: 100%;
  position: absolute;
  top: 48px;
  left: 0px;
  width: 100%;
}
</style>


